import { getOffsetDotPosition } from "../../timezoneDisplay"

import "./index.scss"

// Spec: Multi-TZ Sync Up Detail Group (Notion e8f3d605c41448f98d39588e55f18c8e) — a horizontal
// line with a dot showing this zone's offset vs the viewer's timezone.
const LINE_LENGTH = 120
const DOT_RADIUS = 4

const OffsetIndicator = ({ offsetHours }) => {
  const dotPosition = getOffsetDotPosition(offsetHours, LINE_LENGTH, DOT_RADIUS)

  return (
    <div
      className="people-timezone-row-offset-indicator"
      style={{ width: LINE_LENGTH }}>
      <div className="people-timezone-row-offset-indicator-line" />
      <div
        className="people-timezone-row-offset-indicator-dot"
        style={{
          left: dotPosition - DOT_RADIUS,
          width: DOT_RADIUS * 2,
          height: DOT_RADIUS * 2,
        }}
      />
    </div>
  )
}

export default OffsetIndicator
